import CompanyRoomPage from 'src/components/pages/Company/CompanyAccountPage/CompanyAccountPage';

export default CompanyRoomPage;
